import { render, staticRenderFns } from "./JciProgramPaymentReport.vue?vue&type=template&id=72b1b4ba&scoped=true"
import script from "./JciProgramPaymentReport.vue?vue&type=script&lang=js"
export * from "./JciProgramPaymentReport.vue?vue&type=script&lang=js"
import style0 from "./JciProgramPaymentReport.vue?vue&type=style&index=0&id=72b1b4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1b4ba",
  null
  
)

export default component.exports